export const REASONS = {
    duplicated: 'Atestado duplicado. Já existe um documento com a mesma data cadastrado'
};
